module.exports = __webpack_public_path__ + "img/icon-misalignment.b88e6b22.svg";